import createClient from '../../apolloClient';
import MUTATION_RESTORE_USER from '../../mutation/restoreUser';

const handleRestoreUser = async (variables) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: MUTATION_RESTORE_USER,
    variables,
  });
  const { restoreUser } = result?.data || {};
  return restoreUser;
};

export default handleRestoreUser;
